export const scrollTop = () => {
	return window.scrollTo(0, 0);
};
